import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import myImage04 from '../image/04.jpg';
import myImage05 from '../image/05.jpg';
import myImage06 from '../image/06.jpg';
import myImage07 from '../image/07.jpg';

export default function Products() {
  const { t } = useTranslation();
  const [hoveredId, setHoveredId] = useState<number | null>(null);

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const products = [
    {
      id: 1,
      nameKey: 'product_1_name',
      categoryKey: 'product_1_category',
      image: myImage04,
    },
    {
      id: 2,
      nameKey: 'product_2_name',
      categoryKey: 'product_2_category',
      image: myImage05,
    },
    {
      id: 3,
      nameKey: 'product_3_name',
      categoryKey: 'product_3_category',
      image: myImage06,
    },
    {
      id: 4,
      nameKey: 'product_4_name',
      categoryKey: 'product_4_category',
      image: myImage07,
    },
  ];

  return (
    <section id="products" className="py-20 sm:py-32 bg-[#2a1f14]" data-product-shop>
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-6 mb-12 sm:mb-16">
          <div className="inline-block border border-[#c9a96e]/50 rounded-full px-5 py-2 self-start">
            <span className="text-sm font-medium text-[#c9a96e] whitespace-nowrap">{t('products_badge')}</span>
          </div>
          <h2 className="text-4xl sm:text-5xl lg:text-7xl font-bold text-[#f5ede0] leading-tight sm:max-w-2xl sm:text-right">
            {t('products_title_1')}
            <br />
            {t('products_title_2')}
          </h2>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-8">
          {products.map((product) => (
            <div
              key={product.id}
              className="group cursor-pointer"
              onMouseEnter={() => setHoveredId(product.id)}
              onMouseLeave={() => setHoveredId(null)}
            >
              <div className="bg-[#f5ede0] rounded-xl sm:rounded-2xl overflow-hidden mb-3 sm:mb-4 relative">
                <div className="w-full h-[220px] sm:h-[320px] lg:h-[400px]">
                  <img
                    src={product.image}
                    alt={t(product.nameKey)}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
                  />
                </div>
              </div>
              <div className="space-y-1">
                <h3 className="text-sm sm:text-lg font-semibold text-[#f5ede0]">{t(product.nameKey)}</h3>
                <p className="text-xs sm:text-sm text-[#c9a96e]">{t(product.categoryKey)}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 sm:mt-16 text-center">
          <button
            onClick={scrollToContact}
            className="bg-[#c9a96e] text-[#2a1f14] px-8 sm:px-10 py-3 sm:py-4 rounded-lg font-medium hover:bg-[#b8864e] transition-colors whitespace-nowrap cursor-pointer text-sm sm:text-base">
            {t('products_view_all')}
          </button>
        </div>
      </div>
    </section>
  );
}
